import { StudentsService } from "./../../services/students.service";
import { IEmployeeContact } from "./../../services/parent.services.models";
import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef } from "@angular/core";
import AsyncComponent from "../common/AsyncComponent";
import { ContactModel } from "./models/ContactWidgetModel";
import { RoleServiceFactoryService } from "./../../services/role-service-factory.service";
import { ProfileService } from "../../services/profile.service";
import { AnalyticsService } from "../../services/analytics.service";
import { SchoolService } from "../../services/school.service";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-contact-widget",
  templateUrl: "./contact-widget.component.html",
  styleUrls: ["./contact-widget.component.scss"],
})
export class ContactWidgetComponent implements OnInit, AsyncComponent {
  @Input() model: IEmployeeContact = null;
  @Output() command: EventEmitter<any> = new EventEmitter<any>();

  favContact1 = false;
  favContact2 = true;
  // async component
  loaded: boolean;
  imgStudent: string = null;
  imgProfile: string = null;
  schoolName: string = 'N/A';

  role = this.profileService.role;

  get isProd() {
    if(environment.environment_name == 'Production') return true
    else return false
  }


  constructor(
    private studentService: StudentsService,
    public rs: RoleServiceFactoryService,
    private profileService: ProfileService,
    private analytics: AnalyticsService,
    private schoolService: SchoolService,
  ) {}

  ngOnInit(): void {
    if(this.role == 'Administrator'){
      this.getSchoolName();
    }
  }

  getSchoolName(){
    this.schoolService.getSchoolsById([this.model.schoolCode]).subscribe(res => {
      this.schoolName = res[0].schoolName;
    })
  }

  message() {
    this.command.emit({ name: "message", source: this.model });
  }
  profile() {
    this.analytics.sendEvent("User Click", "Contact Details");
    this.command.emit({ name: "profile", source: this.model });
  }

  onImgError(event, model) {
    if (model.role === "Student") {
      event.target.src = "./assets/img/icons/student.svg";
    } else if (model.role === "Teacher") {
      event.target.src = "./assets/img/icons/principal.svg";
    } else if (model.role === "Principal") {
      event.target.src = "./assets/img/icons/teacher.svg";
    }
  }

  onImgTeacherError(event, getType) {
    console.log(getType.profile);
    const getVendorType =
      getType.profile == "principal"
        ? "Principal"
        : getType.profile == "employee"
        ? "Teacher"
        : "Student";
    if (getVendorType === "Student") {
      event.target.src = "./assets/img/icons/student.svg";
    } else if (getVendorType === "Teacher") {
      event.target.src = "./assets/img/icons/principal.svg";
    } else {
      event.target.src = "./assets/img/icons/teacher.svg";
    }
  }

  get studentsNum() {
    return this.model?.studentDistrictId?.length || 0;
  }
}
